import { ClienteFincaBaseResponse } from "../../../../modulos/terceros/response/ClienteFincaBaseResponse";
import {
  fx_createTareaEjecucionRequest,
  TareaEjecucionRequest,
} from "../../../../modulos/rastro/request/TareaEjecucionRequest";
import { TareaEjecucionResponse } from "../../../../modulos/rastro/response/TareaEjecucionResponse";
import { TareaEjecucionSaveGrpcService } from "../../../../modulos/rastro/services/TareaEjecucionSaveGrpcService";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { BaseFullScreenFormModalRender } from "../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { TareaEjecucionFormRender } from "../form/TareaEjecucionFormRender";

/** Modal a pantalla completa de edición de una ejecución de tarea: tiles de
 *  contexto (dispositivo + fechas) + tarea a asignar + detalle de productos. */
export class TareaEjecucionEditModal extends BaseFullScreenFormModalRender<
  TareaEjecucionRequest,
  TareaEjecucionResponse
> {
  protected readonly elementId = "tareaEjecucionEditModal";

  constructor(
    private readonly _ejecucion: TareaEjecucionResponse,
    private readonly _finca: ClienteFincaBaseResponse,
  ) {
    super(fx_createTareaEjecucionRequest(_ejecucion));
  }

  protected get title(): string {
    return "Editar ejecución";
  }

  protected get subtitle(): string | undefined {
    return this._finca.nombreFinca;
  }

  protected getFormBody(): IFormBodyRender {
    return new TareaEjecucionFormRender(
      this._request,
      this._ejecucion,
      this._finca,
    );
  }

  protected get saveService(): ISaveService<
    TareaEjecucionRequest,
    TareaEjecucionResponse
  > {
    return new TareaEjecucionSaveGrpcService(this._finca.id);
  }
}
